import { createDate, isBefore, isSameOrAfter, subtract } from '@lingoda/dates';

export const isAboutToEndClass = (endDate: string, now: Date = createDate()) =>
    isSameOrAfter(now, getAboutToEndClassDate(endDate)) && isBefore(now, createDate(endDate));

export const getAboutToEndClassDate = (endDate: string) =>
    subtract({ minutes: 5 }, createDate(endDate));
